module.exports = __webpack_public_path__ + "img/fj.b92ebc00.svg";